import React from "react";

import { legendItemStyle, legendStyle } from "../style";

export const SeismicIslNatcatLegend = ({ customLegendStyle = legendStyle }) => {
  return (
    <div style={customLegendStyle}>
      <div>
        <b>Seismic Risk GEM Iceland</b>
      </div>
      <div>
        <span style={legendItemStyle("#ff4c00")}></span> &gt; 0.9
      </div>
      <div>
        <span style={legendItemStyle("#ffa30a")}></span>0.55 - 0.9
      </div>
      <div>
        <span style={legendItemStyle("#ffd121")}></span>0.35 - 0.55
      </div>
      <div>
        <span style={legendItemStyle("#fffa14")}></span>0.2 - 0.35
      </div>
      <div>
        <span style={legendItemStyle("#e8f59e")}></span>0.13 - 0.2
      </div>
      <div>
        <span style={legendItemStyle("#abcf63")}></span>0.08 - 0.13
      </div>
      <div>
        <span style={legendItemStyle("#7f97ff")}></span>0.05 - 0.08
      </div>
      <div>
        <span style={legendItemStyle("#8fb3ff")}></span>0.03 - 0.05
      </div>
      <div>
        <span style={legendItemStyle("#b5caff")}></span>0.02 - 0.03
      </div>
      <div>
        <span style={legendItemStyle("#d7e3ee")}></span>0.01 - 0.02
      </div>
      <div>
        <span style={legendItemStyle("#ffffff")}></span> &lt; 0.01
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from Global Earthquake Model Foundation processed by CyStellar
        </span>
      </div>
    </div>
  );
};
